const BASE_URL = "https://avsportal.kuleanpay.com/api/v1";

export function getAPIEndpoint(type, hasParams = false) {
    let url = null;
    switch (type) {
        case 'stats':
            url = `${BASE_URL}/stats`
            break;
        case 'trxns':
            url = `${BASE_URL}/transactions`;
            break;
        case 'recent_trxns':
            url = `${BASE_URL}/recent_transactions`;
            break;
        case 'trxn_count':
            url = `${BASE_URL}/transaction_count`;
            break;
        case 'auth':
            url = `${BASE_URL}/authenticate`;
            break;
        case 'balance':
            url = `${BASE_URL}/balance`;
            break;
        case 'error':
            url = `${BASE_URL}/errorlog`;
            break;
        case 'agent':
            url = `${BASE_URL}/agents`;
            break;
        case 'agent-delete':
            url = `${BASE_URL}/agents/delete`;
            break;
        case 'agent-edit':
            url = `${BASE_URL}/agents/edit`;
            break;
        case 'user':
            url = `${BASE_URL}/users`;
            break;
        case 'user-delete':
            url = `${BASE_URL}/users/delete`;
            break;
        case 'user-edit':
            url = `${BASE_URL}/users/edit`;
            break;
        case 'role':
            url = `${BASE_URL}/roles`;
            break;
        case 'topup-hist':
            url = `${BASE_URL}/topup_history`;
            break;
        case 'topup-hist-client':
            url = `${BASE_URL}/topup_history/client`;
            break;
        case 'topup-edit':
            url = `${BASE_URL}/topup_history/edit`;
            break;
        case 'topup-delete':
            url = `${BASE_URL}/topup_history/delete`;
            break;
        default:
            break;
    }
    return url;
}

export const AUTH_ERROR_MSG = 'Sorry, we are unable to verify your credentials at this time. Please try again later.';